import { MdFileUpload } from "react-icons/md";
import Card from "components/card";
import React, { useState } from "react";
import ApiList from "services/apiList";
import { currentUser } from "services/users/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "services/users/authSlice";
import { successToast } from "services/globalFunctions";
import { errorToast } from "services/globalFunctions";
import CustomButton from "components/button/custom_button";

const Upload = () => {
  const [image, setImage] = useState();
  const [fileName, setFileName] = useState("No selected file");
  const user = useSelector(currentUser);
  const dispatch = useDispatch();
  async function uploadProfile() {
    if (image !== undefined && image !== null) {
      const formData = new FormData();
      formData.append("id", user.id);
      formData.append("image", image);
      await fetch(ApiList.uploadProfileUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            dispatch(loginUser(data["result"]));
            successToast(data["message"]);
            setImage(null);
          }
        })
        .catch((error) => {
          errorToast("Файл сонгоно уу!");
        });
    } else {
      errorToast("Файл сонгоно уу!");
    }
  }
  return (
    <Card className="grid h-full w-full grid-cols-1 gap-3 rounded-[20px] bg-white bg-clip-border p-3 font-dm shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none 2xl:grid-cols-11">
      <div className="col-span-5 h-full w-full rounded-xl bg-lightPrimary dark:!bg-navy-700 2xl:col-span-6">
        <button
          className="flex h-full w-full flex-col items-center justify-center rounded-xl border-[2px] border-dashed border-gray-200 p-1 dark:!border-navy-700 "
          onClick={() => {
            document.querySelector(".input-file-field").click();
          }}
        >
          <input
            type="file"
            accept="image/*"
            className="input-file-field"
            onChange={({ target: { files } }) => {
              files[0] && setFileName(files[0].name);
              if (files) {
                setImage(files[0]);
              }
            }}
            hidden
          />
          {image ? (
            <img
              src={URL.createObjectURL(image)}
              alt={fileName}
              className="h-full w-full border-[2px] object-cover"
            />
          ) : (
            <div>
              <MdFileUpload className="text-[80px] text-brand-500 dark:text-white" />
              <h4 className="text-xl font-bold text-brand-500 dark:text-white">
                Профайл зураг оруулах
              </h4>
              <p className="mt-2 text-sm font-medium text-gray-600">
                PNG, JPG, GIF өргөтгөлтөй файл зөвшөөрөгдөнө
              </p>
            </div>
          )}
        </button>
      </div>

      <div className="col-span-5 flex h-full w-full flex-col justify-center overflow-hidden rounded-xl bg-white pl-3 pb-4 dark:!bg-navy-800">
        <h5 className="text-left text-xl font-bold leading-9 text-navy-700 dark:text-white">
          Профайл зураг
        </h5>
        <p className="leading-1 mt-2 text-base font-normal text-gray-600">
          Та профайл зургаа өөрчлөхийг хүсвэл энд оруулна уу.
        </p>

        <CustomButton
          onClick={() => {
            uploadProfile();
          }}
          text="Хадгалах"
          type="button"
          className="mr-3"
        />
      </div>
    </Card>
  );
};

export default Upload;
